import { render, staticRenderFns } from "./nc-order-modal.vue?vue&type=template&id=66341dc4&"
import script from "./nc-order-modal.vue?vue&type=script&lang=js&"
export * from "./nc-order-modal.vue?vue&type=script&lang=js&"
import style0 from "./nc-order-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66341dc4')) {
      api.createRecord('66341dc4', component.options)
    } else {
      api.reload('66341dc4', component.options)
    }
    module.hot.accept("./nc-order-modal.vue?vue&type=template&id=66341dc4&", function () {
      api.rerender('66341dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/nc-order-modal.vue"
export default component.exports